import React, {PureComponent} from 'react';
import {connect} from "react-redux";
// import {RouteComponentProps} from 'react-router-dom';
import {Layout, Card} from 'antd';
import ResetPasswordForm from "@components/auth/ResetPasswordForm";
import {resetPasswordRequest} from '@actions/auth';

const {Content} = Layout;

interface AllProps {
  resetPasswordRequest: typeof resetPasswordRequest;
  history: any;
}

class ResetPasswordPage extends PureComponent<AllProps> {
  render() {
    const {resetPasswordRequest, history} = this.props;
    return (
      <Layout>
        <Content>
          <Card className={'login-form-wrapper'}>
            <ResetPasswordForm
              resetPasswordRequest={resetPasswordRequest}
              history={history}
            />
          </Card>
        </Content>
      </Layout>
    )
  }
}

const mapDispatchToProps = {
  resetPasswordRequest
};

export default connect(null, mapDispatchToProps)(ResetPasswordPage);


